import { browser } from '$app/env';

export function copyToClipboard(elt: HTMLElement) {
	if (!browser) {
		return;
	}
	// Select the div content
	const range = document.createRange();
	range.selectNode(elt);
	const selection = window.getSelection();
	if (!selection) return;
	selection.removeAllRanges(); // Clear any current selections
	selection.addRange(range); // Add the range to the selection

	// Copy the selection to the clipboard
	document.execCommand('copy');
	// Clean up the selection
	selection.removeAllRanges();
}
